export default {
  en: {
    titleLineOne: 'Great to have you',
    titleLineTwo: 'On Board!',
    subtitleOne: 'The next steps will guide you through the product to set up\n' +
      'your club ready to take bookings at your own pace.',
    subtitleTwo: 'Don\'t worry, our team is always here to help!',
  },
};
